import React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../../Config/Config";
import { useNavigate, useLocation } from "react-router-dom";
import { CommonMethods } from "./../../components/common/CommonMethods";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Alert from "@mui/material/Alert";

import {
  AddProductAPI,
  AddCompanyURLAPI,
  AddModuleAPI,
  addEmailCredentialApi,
  addDbCredentialApi,
  fetchEmailCredentialDetails,
  fetchDbCredentialDetails,
  fetchUserDetails,
  setnewenvAPI,
  // getuserReset,
  clearStorage,
  // googleAuthcredentials,
  getStaticIntegrations,
  getIntegrations,
  addIntegration,
  deleteIntegrations,
  setLLmdetails,
  getLLmsetup,
  companySetting,
  getCompanyDeviceListDetails,
  updateCompanyDeviceList,
  setCompanyresolutionAPI,
  // updateUserType,
  getresolutionAPI,
  setCompanyURLAPI,
  geturlsAPI,
} from "./../../API/adminAPI";

import useProductQuery from "../../useQuery/useProductQuery";
import {
  useUpdateLLM,
  useGetSysPropsQuery,
  useAddSysPropMutation,
  useUpdateSysPropMutation,
  useDeleteSysPropMutation,
} from "../../useQuery";
import { useQueryClient } from "@tanstack/react-query";
import DesignPrinciplesTab from "../../pages/AdminPage/DesignPrinciplesTab";
import {
  Grid,
  Card,
  Paper,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Switch,
  FormControlLabel,
  Divider,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { colorExport } from "./../../components/common/common.Component";
import Resolution from "./Resolution";
import ExecutionSetup from "./execution";
import FrameworkSetup from "./FrameworkSetup";
import CustomDialog from "../../components-new/common/CustomDialog";
import SystemDeviceEditor from "../../components-new/common/SystemDeviceEditor";
import { useNotification } from "../../hooks";
import { ADMIN_SIDEBAR_MENUS } from "../Studio/constants";

function FormCard({ title, children }) {
  return (
    <Paper elevation={2} sx={{ p: 2, minHeight: 200 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      {children}
      <Button variant="contained" size="small" sx={{ mt: 2 }}>
        Submit
      </Button>
    </Paper>
  );
}

export default function PropertiesPage({ showLlmForm, setShowLlmForm, onSubFormChange }) {
  const queryClient = useQueryClient();
  const colors = colorExport();
  const userDetails = localStorage.getItem("colorcode");
  const temp = JSON.parse(userDetails);
  const DBTypeLIstData = [
    { value: "Oracle", name: "Oracle" },
    { value: "MongoDB", name: "MongoDB" },
    { value: "MYSQL", name: "MySQL" },
    { value: "MSSQL", name: "MS SQL" },
    { value: "Other", name: "Other" },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const [selectedForm, setSelectedForm] = useState(location.state?.subTab || null);
  const [showNew, setShowNew] = useState(false);
  const [productError, setProductError] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const [toDate, setToDate] = useState(null);
  const { data: productList = [] } = useProductQuery();
  const [integrationDatas, setIntegratonData] = useState([]);
  const [newProductName, setNewProductName] = useState("");
  const [companydata, setcompanyData] = useState(null);
  const [credEmailData, setEmailCredData] = useState({
    idproducts: "",
    port: "",
    host: "",
    protocol: "",
    action: "",
    sendport: "",
    sendhost: "",
  });
  const [selectIntegration, setSelectIntegration] = useState(null);
  const [userData, setUserData] = useState([]);
  const notify = useNotification();
  const updateLLMMutation = useUpdateLLM();
  const [cloudType, setCloudType] = useState({
    idproducts: "",
    cloudTypes: "",
    url: "",
    token: "",
    userName: "",
    password: "",
  });
  const [credDbData, setDbCredData] = useState({
    idproducts: "",
    custDbType: "",
    custDbUrl: "",
    custDbUsername: "",
    custDbPwd: "",
    DBOtherType: "",
  });
  const [selectedIntegration, setSelectedIntegration] = useState([]);
  const [product, setproduct] = useState("");
  const [TestDataDetails, setTestDataDetails] = useState({
    file: "",
    filename: "",
    companyurl: temp.companyurl,
  });
  const [newModuleName, setNewModuleName] = useState("");
  const [intName, setIntName] = useState(null);
  const [uploadedFile, setUploadedFile] = useState({
    file: "",
    filename: "",
  });
  const [openAlert, setOpenAlert] = useState(false);
  const [DeleteAlert, setDeleteAlert] = useState(false);
  const [companyURL, setCompanyURL] = useState(temp.companyurl);
  const [llmForm, setLlmform] = useState({
    LLMName: "",
    LLM: "",
    apiKey: "",
    model: "",
  });
  const [urlsetup, setUrlsetup] = useState([]);
  const [resolution, setResolution] = useState({
    web: [],
    mobile: [],
  });

  const [llmList, setLlmList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [deviceList, setDeviceList] = useState({});
  const [deviceListDialogOpen, setDeviceListDialogOpen] = useState(false);
  const [editingSystemName, setEditingSystemName] = useState(null); // null => adding a new system
  const [systemForm, setSystemForm] = useState({ name: "", devices: [] });
  const [savingDeviceList, setSavingDeviceList] = useState(false);
  // Text currently typed in the "Device name" input (not yet committed with "+")
  const [systemDeviceInput, setSystemDeviceInput] = useState("");

  // System Property
  const [sysPropForm, setSysPropForm] = useState({
    id: "",
    name: "",
    value: "",
    comment: "",
  });
  const [editingSysIndex, setEditingSysIndex] = useState(null);
  const sysPropFormRef = useRef(null);

  const { data: sysPropList = [] } = useGetSysPropsQuery(selectedForm === "system");
  const addSysPropMutation = useAddSysPropMutation();
  const updateSysPropMutation = useUpdateSysPropMutation();
  const deleteSysPropMutation = useDeleteSysPropMutation();
  useEffect(() => {
    getUserData();
  }, []);

  const formatDate = (date) => {
    if (date) {
      return dayjs(date).format("DD/MM/YYYY");
    }
    return "";
  };

  const handleChange = (e) => {
    setLlmform({ ...llmForm, [e.target.name]: e.target.value });
  };
  const resetLLMForm = () => {
    setLlmform({ LLMName: "", LLM: "", apiKey: "", model: "" });
    setEditingId(null);
    setShowLlmForm(false);
  };

  const sendLLMdetails = () => {
    if (editingId) {
      updateLLMMutation.mutate(
        { data: llmForm, id: editingId },
        {
          onSuccess: (response) => {
            notify(response?.data?.message || "LLM details updated successfully", "success");
            getLLMsetup();
            resetLLMForm();
          },
          onError: (error) => {
            notify(error?.response?.data?.error || "Failed to update LLM details", "error");
          },
        },
      );
      return;
    }

    setLLmdetails(llmForm, false)
      .then((response) => {
        notify(response?.data?.message || "LLM details saved successfully", "success");
        getLLMsetup();
        resetLLMForm();
      })
      .catch((error) => {
        notify(error?.response?.data?.error || "Failed to save LLM details", "error");
      });
  };
  const getLLMsetup = async () => {
    await getLLmsetup()
      .then((data) => {
        setLlmList(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditLLM = (row) => {
    setShowLlmForm(true);
    setEditingId(row.id);
    setLlmform({
      LLMName: row.name ?? "",
      LLM: row.url ?? "",
      apiKey: row.api_key ?? "",
      model: row.model ?? "",
    });
  };

  // --- System Property handlers (local state only) ---
  const handleSysPropChange = (e) => {
    setSysPropForm({ ...sysPropForm, [e.target.name]: e.target.value });
  };

  const resetSysPropForm = () => {
    setSysPropForm({ id: "", name: "", value: "", comment: "" });
    setEditingSysIndex(null);
  };

  const handleSubmitSysProp = () => {
    if (editingSysIndex !== null) {
      // update path - backend matches on id; supports rename
      updateSysPropMutation.mutate(
        {
          id: sysPropForm.id,
          name: sysPropForm.name,
          value: sysPropForm.value,
          comment: sysPropForm.comment,
        },
        {
          onSuccess: (response) => {
            if (response?.data?.success) {
              notify(response?.data?.message || "System property updated successfully", "success");
              resetSysPropForm();
            } else {
              notify(response?.data?.message || "Failed to update system property", "error");
            }
          },
          onError: (error) => {
            notify(error?.response?.data?.message || "Failed to update system property", "error");
          },
        },
      );
      return;
    }

    // add path - ID auto-generated by DB, so don't send it
    addSysPropMutation.mutate(
      {
        name: sysPropForm.name,
        value: sysPropForm.value,
        comment: sysPropForm.comment,
      },
      {
        onSuccess: (response) => {
          notify(response?.data || "System property added successfully", "success");
          resetSysPropForm();
        },
        onError: (error) => {
          notify(error?.response?.data?.error || "Failed to add system property", "error");
        },
      },
    );
  };

  const handleEditSysProp = (index) => {
    setEditingSysIndex(index);
    setSysPropForm(sysPropList[index]);
    sysPropFormRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDeleteSysProp = (row, index) => {
    // backend deletes by idsysprops (returned as row.id from query)
    deleteSysPropMutation.mutate(row.id, {
      onSuccess: (response) => {
        notify(response?.data || "System property deleted successfully", "success");
        if (editingSysIndex === index) {
          resetSysPropForm();
        }
      },
      onError: (error) => {
        notify(error?.response?.data?.error || "Failed to delete system property", "error");
      },
    });
  };

  const companysetting = async () => {
    await companySetting()
      .then((response) => {
        setcompanyData(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getDeviceList = async () => {
    await getCompanyDeviceListDetails()
      .then((data) => {
        const raw = data?.deviceList;
        try {
          setDeviceList(typeof raw === "string" ? JSON.parse(raw) : raw || {});
        } catch (error) {
          setDeviceList({});
          notify("Failed to parse device list", "error");
        }
      })
      .catch((error) => {
        notify(error?.response?.error || "Failed to fetch device list", "error");
      });
  };

  const openAddSystemDialog = () => {
    setEditingSystemName(null);
    setSystemForm({ name: "", devices: [] });
    setSystemDeviceInput("");
    setDeviceListDialogOpen(true);
  };

  const openEditSystemDialog = (systemName) => {
    setEditingSystemName(systemName);
    setSystemForm({
      name: systemName,
      devices: Array.isArray(deviceList[systemName]) ? [...deviceList[systemName]] : [],
    });
    setSystemDeviceInput("");
    setDeviceListDialogOpen(true);
  };

  const closeSystemDialog = () => {
    setDeviceListDialogOpen(false);
    setEditingSystemName(null);
    setSystemForm({ name: "", devices: [] });
    setSystemDeviceInput("");
  };

  const handleAddDeviceToForm = (device) => {
    setSystemForm((prev) => ({ ...prev, devices: [...prev.devices, device] }));
  };

  const handleDeleteDeviceFromForm = (index) => {
    setSystemForm((prev) => ({ ...prev, devices: prev.devices.filter((_, i) => i !== index) }));
  };

  const persistDeviceList = async (updatedDeviceList) => {
    setSavingDeviceList(true);
    try {
      const response = await updateCompanyDeviceList(updatedDeviceList);
      if (response?.success) {
        setDeviceList(updatedDeviceList);
        notify("Device list updated successfully", "success");
        return true;
      }
      notify("Failed to update device list", "error");
      return false;
    } catch (error) {
      notify(error?.response?.error || "Failed to update device list", "error");
      return false;
    } finally {
      setSavingDeviceList(false);
    }
  };

  const systemNameTrimmed = systemForm.name.trim();
  const isDuplicateSystemName = Object.keys(deviceList).some(
    (n) => n.toLowerCase() === systemNameTrimmed.toLowerCase() && n !== editingSystemName,
  );

  const handleSaveSystem = async () => {
    if (!systemNameTrimmed || isDuplicateSystemName) return;

    // Include a device typed in the input but not yet added with "+"
    const pendingDevice = systemDeviceInput.trim();
    const finalDevices =
      pendingDevice &&
      !systemForm.devices.some(
        (d) => typeof d === "string" && d.toLowerCase() === pendingDevice.toLowerCase(),
      )
        ? [...systemForm.devices, pendingDevice]
        : systemForm.devices;

    const updated = { ...deviceList };
    if (editingSystemName && editingSystemName !== systemNameTrimmed) {
      delete updated[editingSystemName];
    }
    updated[systemNameTrimmed] = finalDevices;
    const success = await persistDeviceList(updated);
    if (success) closeSystemDialog();
  };

  const handleDeleteSystem = async (systemName) => {
    const updated = { ...deviceList };
    delete updated[systemName];
    await persistDeviceList(updated);
  };

  const setClearStorage = async (data) => {
    await clearStorage(data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            // console.log("saveCredentialDetail", response);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getIntegrationDrop = async (id, name) => {
    await getIntegrations(id, name)
      .then((response) => {
        if (response.status == 200 && response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setIntegratonData(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sendCompanyURL = async (name) => {
    await AddCompanyURLAPI(name)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            // console.log("Company URL Updated Successfully");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmiturl = async () => {
    await setCompanyURLAPI(urlsetup, product)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            // console.log("Company URL Updated Successfully");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const setnewenv = async () => {
    await setnewenvAPI(newUrl, product)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            geturls(product);
            setNewUrl("");
            setShowNew(false);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const geturls = async (prod) => {
    if (prod === "") return setUrlsetup([]);
    await geturlsAPI(prod)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            setUrlsetup(response.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getresolution = async (prod) => {
    await getresolutionAPI(prod)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            // Set all resolutions
            setResolution({
              web: response.data.web || [],
              mobile: response.data.mobile || [],
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onSubmitres = async (newResolutionData) => {
    const payload = {
      webWidth: newResolutionData.webWidth || "",
      webHeight: newResolutionData.webHeight || "",
      mobileWidth: newResolutionData.mobileWidth || "",
      mobileHeight: newResolutionData.mobileHeight || "",
    };

    await setCompanyresolutionAPI(payload, product)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            notify("Failed to add resolution", "error");
            CommonMethods(navigate);
          } else {
            notify("Resolution added successfully", "success");
            getresolution(product);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        notify("Failed to add resolution", "error");
      });
  };

  const renderTextFields = () => {
    if (!selectIntegration) return null;

    let selectedIntegrationData = selectedIntegration.find(
      (item) => item.staticintid === selectIntegration,
    );
    if (!selectedIntegrationData) return null;
    const adminAttributesArray = selectedIntegrationData.admin_attributes
      ? selectedIntegrationData.admin_attributes.split(",")
      : [];
    // const valueTextField = (integrationDatas || Object.keys(integrationDatas).length !== 0) ? integrationDatas.adminprop.split(',') : null
    const valueTextField = integrationDatas.adminprop ? integrationDatas.adminprop.split(",") : [];
    return adminAttributesArray.map((attribute, index) => (
      <div key={index} className="input-group">
        <label>{attribute}</label>
        <TextField
          value={valueTextField[index] || ""}
          onChange={(event) => {
            event.preventDefault();
            const updatedValueTextField = [...valueTextField];
            updatedValueTextField[index] = event.target.value;
            setIntegratonData((prevIntegrationDatas) => ({
              ...prevIntegrationDatas,
              adminprop: updatedValueTextField.join(","),
            }));
          }}
          type="text-cred"
          fullWidth
        />
      </div>
    ));
  };
  const AddStaticIntegration = async (id, intName, adminprop) => {
    await addIntegration(id, intName, adminprop)
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const IntegrationDelete = async (intid) => {
    await deleteIntegrations(intid)
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          const updatedIntegrationData = {
            ...integrationDatas,
            adminprop: null,
          };
          setIntegratonData(updatedIntegrationData);
          setDeleteAlert(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleIntegrationChange = (event) => {
    const integrationId = event.target.value;
    setSelectIntegration(integrationId);
    const name = selectedIntegration.map((item, index) =>
      item.staticintid === event.target.value ? item.intname : null,
    );
    const nameNew = name.find((value) => value !== null);
    setIntName(nameNew);
    getIntegrationDrop(cloudType.idproducts, nameNew);
  };

  const sendProduct = async (name) => {
    await AddProductAPI(name)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            console.log("add module succesful");
            queryClient.invalidateQueries({ queryKey: ["products"] });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uploadGooleOauth = () => {
    const userDetails = localStorage.getItem("userDetail");
    const temp = JSON.parse(userDetails);

    fetch(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=gcreds&companyid=${temp.companyid}&fileName=${uploadedFile.file[0].name}`,
      {
        method: "POST",
        body: uploadedFile.file[0],
        headers: {
          "content-type": uploadedFile.file[0].type,
          "content-length": `${uploadedFile.file[0].size}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        // Assuming the JSON response contains a URL field
        const { url } = data;

        // Open a new tab with the URL from the JSON response
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFileUpload = (e) => {
    // const file = event.target.files[0];
    // console.log('Selected file:', file.name);
    // setUploadedFile(file);
    if (e.target.files) {
      console.log("e.target.files", e.target.files);
      console.log("e------------> ", e);
      setUploadedFile({
        file: e.target.files,
        filename: e.target.files[0].name,
      });
    }
  };

  const handleUploaddata = () => {
    const userDetails = localStorage.getItem("userDetail");
    const temp = JSON.parse(userDetails);
    const Response = axios
      .get(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getBranding&companyid=${temp.companyid}`,
      )
      .then((response) => {
        localStorage.setItem(
          "colorcode",
          JSON.stringify({
            brandLogo: response.data.brandLogo,
            primaryColor: response.data.primaryColor,
            secondaryColor: response.data.secondaryColor,
            tertiaryColor: response.data.tertiaryColor,
            companyurl: response.data.companyurl,
          }),
        );

        navigate("/dashboard/app");
      })
      .catch((error) => {
        console.log(error.response.data.error);
      });
    return Response;
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      setTestDataDetails({
        ...TestDataDetails,
        file: e.target.files,
        filename: e.target.files[0].name,
      });
    }
  };
  const sendModule = async (id, name) => {
    await AddModuleAPI(id, name)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            console.log("add module succesful");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleUpload = () => {
    const userDetails = localStorage.getItem("userDetail");
    const temp = JSON.parse(userDetails);
    console.log("sanjeev test above");
    if (!TestDataDetails.file[0]) {
      console.log("sanjeev test");
      const Response = axios
        .post(
          `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addBranding&companyid=${temp.companyid}&primaryColor=${encodeURIComponent(TestDataDetails.primary)}&secondaryColor=${encodeURIComponent(TestDataDetails.secondary)}&tertiaryColor=${encodeURIComponent(TestDataDetails.tertiary)}&brandLogo=${"null"}`,
          TestDataDetails,
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
      return Response;
    } else {
      console.log("sanjeev test");
      fetch(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addBranding&companyid=${temp.companyid}&primaryColor=${encodeURIComponent(TestDataDetails.primary)}&secondaryColor=${encodeURIComponent(TestDataDetails.secondary)}&tertiaryColor=${encodeURIComponent(TestDataDetails.tertiary)}&brandLogo=${TestDataDetails.file[0].name}`,
        {
          method: "POST",
          body: TestDataDetails.file[0],
          headers: {
            "content-type": TestDataDetails.file[0].type,
            "content-length": `${TestDataDetails.file[0].size}`, // 👈 Headers need to be a string
          },
        },
      )
        .then((res) => res.json())
        .catch((err) => console.error(err));
    }
  };

  const getUserData = async (id) => {
    await fetchUserDetails(id)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            console.log("error");
          }
          //   if (response.data[0].status == 3) {
          //     setUserData(response.data);
          //  }
          else {
            setUserData(response.data);
          }
        }
      })
      .catch((error) => {
        console.log("get user details error", error);
      });
  };

  useEffect(() => {
    onSubFormChange?.(selectedForm);
  }, [selectedForm, onSubFormChange]);

  const saveEmailCredentialDetail = async (data) => {
    await addEmailCredentialApi(data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
          } else {
            console.log("saveCredentialDetail", response);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getEmailCredentialDetail = async (api_input) => {
    await fetchEmailCredentialDetails(api_input)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
          } else {
            {
              Object.keys(response.data).length > 0
                ? setEmailCredData({
                    idproducts: api_input,
                    port: response.data.port,
                    host: response.data.host,
                    protocol: response.data.protocol,
                    sendport: response.data.sendport,
                    sendhost: response.data.sendhost,
                  })
                : setEmailCredData({
                    idproducts: api_input,
                    port: "",
                    host: "",
                    protocol: "",
                  });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const AdminIntegration = async () => {
    await getStaticIntegrations()
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          // setIntegratonData(response.data);
          setSelectedIntegration(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDbCredentialDetail = async (api_input) => {
    await fetchDbCredentialDetails(api_input)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            const custDbType = response.data.custDbType;
            const otherDatabaseType = DBTypeLIstData.find((item) => item.value === custDbType)
              ? custDbType
              : "Other";
            {
              Object.keys(response.data).length > 0
                ? setDbCredData({
                    idproducts: api_input,
                    custDbType: otherDatabaseType,
                    custDbUrl: response.data.custDbUrl,
                    custDbUsername: response.data.custDbUsername,
                    custDbPwd: response.data.custDbPwd,
                    DBOtherType: response.data.custDbType, //custDbType
                  })
                : setDbCredData({
                    idproducts: api_input,
                    custDbType: "",
                    custDbUrl: "",
                    custDbUsername: "",
                    custDbPwd: "",
                    DBOtherType: "",
                  });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveDbCredentialDetail = async (data) => {
    await addDbCredentialApi(data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            CommonMethods(navigate);
          } else {
            console.log("saveCredentialDetail", response);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderField = (key, value) => {
    const valStr = String(value).toLowerCase();
    const isBoolean = valStr === "true" || valStr === "false" || valStr === "1" || valStr === "0";

    if (isBoolean) {
      const boolValue = valStr === "true" || valStr === "1";
      return (
        <FormControlLabel
          key={key}
          control={<Switch checked={boolValue} disabled />}
          label={key}
          sx={{ mb: 1 }}
        />
      );
    }

    return (
      <TextField
        key={key}
        label={key}
        value={value ?? ""}
        variant="outlined"
        size="small"
        fullWidth
        InputLabelProps={{ shrink: true }}
        // disabled
        sx={{ mb: 2 }}
      />
    );
  };

  const formComponents = {
    email: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Edit Customer Email Property</h3>
        <Card sx={{ p: 2 }}>
          <Box display="flex" alignItems="center" gap={2} mt={2}>
            <Typography sx={{ width: 100 }}>Product:</Typography>
            <Select
              value={credEmailData.idproducts}
              onChange={(event) => {
                setEmailCredData({
                  ...credEmailData,
                  idproducts: event.target.value,
                });
                getEmailCredentialDetail(event.target.value);
              }}
              fullWidth
              sx={{ height: "2.5rem" }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {productList.map((item, index) => (
                <MenuItem key={index} value={item.idproducts}>
                  {item.productname}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Action */}
          <Box display="flex" alignItems="center" gap={2} mt={2}>
            <Typography sx={{ width: 100 }}>Action:</Typography>
            <Select
              value={credEmailData.action}
              onChange={(event) =>
                setEmailCredData({ ...credEmailData, action: event.target.value })
              }
              fullWidth
              sx={{ height: "2.5rem" }}
            >
              <MenuItem value="ReadEmail">Read Email</MenuItem>
              <MenuItem value="sendEmail">Send Email</MenuItem>
            </Select>
          </Box>

          {/* Conditional Fields */}
          {credEmailData.action === "ReadEmail" && (
            <>
              <Box mt={2} display="flex" gap={2}>
                <Typography sx={{ width: 100 }}>Port:</Typography>
                <TextField
                  value={credEmailData.port}
                  onChange={(e) =>
                    setEmailCredData({ ...credEmailData, port: Number(e.target.value) })
                  }
                  fullWidth
                />
              </Box>
              <Box mt={2} display="flex" gap={2}>
                <Typography sx={{ width: 100 }}>Host:</Typography>
                <TextField
                  value={credEmailData.host}
                  onChange={(e) => setEmailCredData({ ...credEmailData, host: e.target.value })}
                  fullWidth
                />
              </Box>
              <Box mt={2} display="flex" gap={2}>
                <Typography sx={{ width: 100 }}>Protocol:</Typography>
                <TextField
                  value={credEmailData.protocol}
                  onChange={(e) => setEmailCredData({ ...credEmailData, protocol: e.target.value })}
                  fullWidth
                />
              </Box>
            </>
          )}

          {credEmailData.action === "sendEmail" && (
            <>
              <Box mt={2} display="flex" gap={2}>
                <Typography sx={{ width: 100 }}>Port:</Typography>
                <TextField
                  value={credEmailData.sendport}
                  onChange={(e) =>
                    setEmailCredData({
                      ...credEmailData,
                      sendport: Number(e.target.value),
                    })
                  }
                  fullWidth
                />
              </Box>
              <Box mt={2} display="flex" gap={2}>
                <Typography sx={{ width: 100 }}>Host:</Typography>
                <TextField
                  value={credEmailData.sendhost}
                  onChange={(e) => setEmailCredData({ ...credEmailData, sendhost: e.target.value })}
                  fullWidth
                />
              </Box>
            </>
          )}

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              size="small"
              variant="contained"
              onClick={() => saveEmailCredentialDetail(credEmailData)}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    database: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Edit Customer Database Property</h3>
        <Card
          sx={{
            mt: 2, // replace with your colors.tertiaryColor
            p: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Product:
            </Typography>
            <Select
              value={credDbData.idproducts}
              onChange={(event) => {
                setDbCredData({
                  ...credDbData,
                  idproducts: event.target.value,
                });
                getDbCredentialDetail(event.target.value);
              }}
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {productList.map((item, index) => (
                <MenuItem key={index} value={item.idproducts}>
                  {item.productname}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* DB Type */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              DB Type:
            </Typography>
            <Select
              value={credDbData.custDbType}
              onChange={(event) =>
                setDbCredData({
                  ...credDbData,
                  custDbType: event.target.value,
                  DBOtherType: undefined,
                })
              }
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              {DBTypeLIstData.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Other DB Type (conditional) */}
          {credDbData.custDbType === "Other" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Type:
              </Typography>
              <TextField
                value={credDbData.DBOtherType || ""}
                onChange={(event) =>
                  setDbCredData((prev) => ({
                    ...prev,
                    DBOtherType: event.target.value,
                  }))
                }
                fullWidth
              />
            </Box>
          )}

          {/* DB Url */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              DB Url:
            </Typography>
            <TextField
              value={credDbData.custDbUrl}
              onChange={(event) =>
                setDbCredData((prev) => ({
                  ...prev,
                  custDbUrl: event.target.value,
                }))
              }
              fullWidth
            />
          </Box>

          {/* Username */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Username:
            </Typography>
            <TextField
              value={credDbData.custDbUsername}
              onChange={(event) =>
                setDbCredData((prev) => ({
                  ...prev,
                  custDbUsername: event.target.value,
                }))
              }
              fullWidth
            />
          </Box>

          {/* Password */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Password:
            </Typography>
            <TextField
              value={credDbData.custDbPwd}
              type="password"
              inputProps={{
                style: { padding: 7 },
              }}
              onChange={(event) =>
                setDbCredData((prev) => ({
                  ...prev,
                  custDbPwd: event.target.value,
                }))
              }
              fullWidth
            />
          </Box>

          {/* Submit Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="contained"
              sx={{ mt: 1 }}
              onClick={() => saveDbCredentialDetail(credDbData)}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    integrations: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Integrations</h3>
        <Card
          sx={{
            mt: 2,
            p: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Product:
            </Typography>
            <Select
              value={cloudType.idproducts}
              onChange={(event) => {
                setCloudType({
                  ...cloudType,
                  idproducts: event.target.value,
                });
                AdminIntegration(event.target.value);
              }}
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {productList.map((item, index) => (
                <MenuItem key={index} value={item.idproducts}>
                  {item.productname}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Integration Select */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Integration:
            </Typography>
            <Select
              value={selectIntegration || ""}
              onChange={handleIntegrationChange}
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              {selectedIntegration.map((item, index) => (
                <MenuItem key={index} value={item.staticintid}>
                  {item.intname}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Dynamic Input Fields */}
          <Box sx={{ mb: 2 }}>{renderTextFields()}</Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={() => IntegrationDelete(integrationDatas.integrationid)}
            >
              Delete
            </Button>

            <Button
              size="small"
              variant="contained"
              onClick={() => {
                if (Object.keys(integrationDatas).length !== 0) {
                  setOpenAlert(true);
                }
                AddStaticIntegration(cloudType.idproducts, intName, integrationDatas.adminprop);
              }}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    system: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Edit System Property</h3>
        <div className="column">
          <Card ref={sysPropFormRef} sx={{ p: 2, mb: 2 }}>
            <div className="input-group">
              <label>ID:</label>
              <TextField
                name="id"
                value={sysPropForm.id}
                onChange={handleSysPropChange}
                type="text"
                fullWidth
              />
            </div>
            <div className="input-group">
              <label>Name:</label>
              <TextField
                name="name"
                value={sysPropForm.name}
                onChange={handleSysPropChange}
                type="text"
                fullWidth
              />
            </div>
            <div className="input-group">
              <label>Value:</label>
              <TextField
                name="value"
                value={sysPropForm.value}
                onChange={handleSysPropChange}
                type="text"
                fullWidth
              />
            </div>
            <div className="input-group">
              <label>Comment:</label>
              <TextField
                name="comment"
                value={sysPropForm.comment}
                onChange={handleSysPropChange}
                type="text"
                fullWidth
              />
            </div>

            <div className="input-group" style={{ justifyContent: "flex-end" }}>
              {editingSysIndex !== null && (
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={resetSysPropForm}
                >
                  Cancel
                </Button>
              )}
              <Button size="small" variant="contained" sx={{ mt: 1 }} onClick={handleSubmitSysProp}>
                {editingSysIndex !== null ? "Update" : "Submit"}
              </Button>
            </div>
          </Card>

          {/* Submitted System Properties (local only) */}
          <Card sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              System Properties
            </Typography>

            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>ID</b>
                    </TableCell>
                    <TableCell>
                      <b>Name</b>
                    </TableCell>
                    <TableCell>
                      <b>Value</b>
                    </TableCell>
                    <TableCell>
                      <b>Comment</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>Actions</b>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sysPropList.length > 0 ? (
                    sysPropList.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.value}</TableCell>
                        <TableCell>{row.comment}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            sx={{ color: "#2550D1" }}
                            onClick={() => handleEditSysProp(index)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteSysProp(row, index)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No system properties added
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </div>
      </div>
    ),
    themes: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Add Themes</h3>

        <Card sx={{ p: 2, mb: 2 }}>
          <div className="input-group">
            <label>Select Logo:</label>
            <TextField type="file" variant="standard" onChange={handleFileChange} />
          </div>

          <div className="input-group">
            <label>Primary Color:</label>
            <TextField
              value={TestDataDetails.primary}
              onChange={(e) => setTestDataDetails({ ...TestDataDetails, primary: e.target.value })}
              fullWidth
            />
          </div>

          <div className="input-group">
            <label>Secondary Color:</label>
            <TextField
              value={TestDataDetails.secondary}
              onChange={(e) =>
                setTestDataDetails({
                  ...TestDataDetails,
                  secondary: e.target.value,
                })
              }
              fullWidth
            />
          </div>

          <div className="input-group">
            <label>Tertiary Color:</label>
            <TextField
              value={TestDataDetails.tertiary}
              onChange={(e) =>
                setTestDataDetails({
                  ...TestDataDetails,
                  tertiary: e.target.value,
                })
              }
              fullWidth
            />
          </div>

          <div className="input-group" style={{ justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="contained"
              sx={{ mt: 1 }}
              onClick={() => {
                handleUpload();
                setTimeout(() => handleUploaddata(), 2000);
              }}
            >
              Submit
            </Button>
          </div>
        </Card>
      </div>
    ),
    oauth: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Google OAuth Credentials</h3>
        <Card sx={{ p: 2 }}>
          <div className="input-group">
            <label>Upload a file:</label>
            <TextField type="file" variant="standard" onChange={handleFileUpload} />
          </div>

          <div className="input-group" style={{ justifyContent: "flex-end" }}>
            {uploadedFile.file[0] && (
              <Button size="small" variant="contained" sx={{ mt: 1 }} onClick={uploadGooleOauth}>
                Authorize
              </Button>
            )}
          </div>
        </Card>
      </div>
    ),
    product: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Create New Product</h3>
        <div className="card" style={{ backgroundColor: "#fff" }}>
          <div className="input-group">
            <label>Product:</label>
            <TextField
              value={newProductName}
              onChange={(event) => {
                event.preventDefault();
                setNewProductName(event.target.value);
              }}
              type="text-cred"
              fullWidth
            />
          </div>

          <div className="input-group" style={{ justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="contained"
              sx={{ margin: "10px 10px 2px 10px" }}
              onClick={() => {
                sendProduct(newProductName);
                setNewProductName("");
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    ),
    module: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Create New Module</h3>
        <Card
          sx={{
            mt: 2,
            p: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Product:
            </Typography>
            <Select
              value={product}
              onChange={(event) => setproduct(event.target.value)}
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {productList.map((item, index) => (
                <MenuItem key={index} value={item.idproducts}>
                  {item.productname}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Module Name Input */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Module:
            </Typography>
            <TextField
              value={newModuleName}
              onChange={(event) => setNewModuleName(event.target.value)}
              fullWidth
            />
          </Box>

          {/* Submit Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="contained"
              sx={{ mt: 1 }}
              onClick={() => {
                sendModule(product, newModuleName);
                setNewModuleName("");
              }}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    clearStorage: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Clear Storage Before</h3>
        <Card
          sx={{
            p: 2,
            mb: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Date:
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Before Date"
                value={toDate}
                onChange={(date) => setToDate(date)}
                sx={{
                  width: "350px",
                }}
              />
            </LocalizationProvider>
          </Box>

          {/* Action Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                setClearStorage(encodeURIComponent(formatDate(toDate)));
              }}
            >
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    companyUrl: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Create Company URL</h3>

        <Card
          sx={{
            p: 2,
            mb: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Company URL:
            </Typography>
            <TextField
              value={companyURL}
              onChange={(event) => setCompanyURL(event.target.value)}
              fullWidth
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button size="small" variant="contained" onClick={() => sendCompanyURL(companyURL)}>
              Submit
            </Button>
          </Box>
        </Card>
      </div>
    ),
    Companysettings: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>Company Settings</h3>

        {companydata !== null ? (
          <Card>
            {/* <Box display="flex" flexDirection="column"> */}
            {Object.entries(companydata).map(([key, value]) => (
              <Box key={key} sx={{ my: 1 }}>
                {renderField(key, value)}
              </Box>
            ))}
            {/* </Box> */}
          </Card>
        ) : (
          ""
        )}
      </div>
    ),
    LLMSetup: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <h3>LLM Setup</h3>

        {(showLlmForm || editingId) && (
          <Card
            sx={{
              p: 2,
              mb: 2,
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                LLM Name:
              </Typography>
              <TextField name="LLMName" value={llmForm.LLMName} onChange={handleChange} fullWidth />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                LLM URL:
              </Typography>
              <TextField name="LLM" value={llmForm.LLM} onChange={handleChange} fullWidth />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                API Key:
              </Typography>
              <TextField name="apiKey" value={llmForm.apiKey} onChange={handleChange} fullWidth />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Model:
              </Typography>
              <TextField name="model" value={llmForm.model} onChange={handleChange} fullWidth />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button size="small" variant="outlined" sx={{ mr: 1 }} onClick={resetLLMForm}>
                Cancel
              </Button>
              <Button size="small" variant="contained" onClick={() => sendLLMdetails()}>
                {editingId ? "Update" : "Submit"}
              </Button>
            </Box>
          </Card>
        )}
        <Card sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Existing LLM Records
          </Typography>

          <TableContainer component={Paper} sx={{ overflow: "hidden" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 40 }}>
                    <b>ID</b>
                  </TableCell>
                  <TableCell sx={{ width: 80 }}>
                    <b>Name</b>
                  </TableCell>
                  <TableCell sx={{ width: "30%", maxWidth: 200 }}>
                    <b>URL</b>
                  </TableCell>
                  <TableCell sx={{ width: "30%", maxWidth: 200 }}>
                    <b>API Key</b>
                  </TableCell>
                  <TableCell sx={{ width: 100 }}>
                    <b>Model</b>
                  </TableCell>
                  <TableCell align="center" sx={{ width: 60 }}>
                    <b>Actions</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {llmList.length > 0 ? (
                  llmList.map((row, index) => (
                    <TableRow
                      key={index}
                      selected={row.id === editingId}
                      sx={{ "&.Mui-selected": { bgcolor: "rgba(37, 80, 209, 0.2)" } }}
                    >
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 200,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.url}
                      </TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 200,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.api_key}
                      </TableCell>
                      <TableCell>{row.model}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleEditLLM(row)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No LLM records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
    ),
    URlSetup: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <h3>ENV URL</h3>

          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              if (!product) {
                setProductError(true);
                return;
              }
              setShowNew(true);
            }}
          >
            NEW
          </Button>
        </Box>

        <Card sx={{ p: 2, mb: 2 }}>
          {showNew && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                New ENV
              </Typography>

              <TextField
                fullWidth
                value={newUrl}
                onChange={(e) => setNewUrl(e.target.value)}
                sx={{ mb: 1 }}
              />

              <Button size="small" variant="contained" onClick={setnewenv}>
                Submit
              </Button>
            </Box>
          )}
          <Box sx={{ mb: 2 }}>
            {productError && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                Please select a product first
              </Typography>
            )}
            <Typography variant="body2" sx={{ mb: 1 }}>
              Product:
            </Typography>
            <Select
              value={product}
              onChange={(event) => {
                geturls(event.target.value);
                setproduct(event.target.value);
                setProductError(false);
              }}
              fullWidth
              sx={{
                height: "2.5rem",
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {productList?.map((item, index) => (
                <MenuItem key={index} value={item.idproducts}>
                  {item.productname}
                </MenuItem>
              ))}
            </Select>
          </Box>
          {urlsetup?.map((row, index) => (
            <div className="input-group" key={`${row.envname}-${index}`}>
              <label>{row.envname.toUpperCase()} :</label>

              <TextField
                fullWidth
                value={row.envurl ?? ""}
                onChange={(e) => {
                  const value = e.target.value;

                  setUrlsetup((prev) => {
                    const next = [...prev];
                    next[index] = {
                      ...next[index],
                      envurl: value,
                    };
                    return next;
                  });
                }}
              />
            </div>
          ))}

          <div className="input-group" style={{ justifyContent: "flex-end" }}>
            <Button size="small" variant="contained" sx={{ mt: 1 }} onClick={onSubmiturl}>
              Submit
            </Button>
          </div>
        </Card>
      </div>
    ),
    resolution: (
      <Resolution
        product={product}
        setproduct={setproduct}
        productList={productList}
        resolution={resolution}
        setResolution={setResolution}
        getresolution={getresolution}
        onSubmitres={onSubmitres}
      />
    ),
    Execution: <ExecutionSetup />,
    framework: <FrameworkSetup productList={productList} />,
    designPrinciples: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <DesignPrinciplesTab />
      </div>
    ),
    deviceList: (
      <div className="card" style={{ backgroundColor: colors.tertiaryColor }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <h3 style={{ margin: 0 }}>Device List</h3>
          <Button variant="outlined" startIcon={<AddIcon />} onClick={openAddSystemDialog}>
            Add System
          </Button>
        </Box>
        <Card sx={{ p: 2 }}>
          {Object.keys(deviceList).length > 0 ? (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>System</b>
                    </TableCell>
                    <TableCell>
                      <b>Devices</b>
                    </TableCell>
                    <TableCell align="right">
                      <b>Actions</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(deviceList).map(([systemName, devices]) => (
                    <TableRow key={systemName}>
                      <TableCell>{systemName}</TableCell>
                      <TableCell>
                        {Array.isArray(devices) ? devices.join(", ") : String(devices ?? "")}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="small"
                          onClick={() => openEditSystemDialog(systemName)}
                          aria-label={`Edit ${systemName}`}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteSystem(systemName)}
                          sx={{ color: "#d32f2f" }}
                          aria-label={`Delete ${systemName}`}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No devices found
            </Typography>
          )}
        </Card>

        <CustomDialog
          open={deviceListDialogOpen}
          onClose={closeSystemDialog}
          title={editingSystemName ? "Edit System" : "Add New System"}
          width="480px"
          content={
            <SystemDeviceEditor
              name={systemForm.name}
              onNameChange={(value) => setSystemForm((prev) => ({ ...prev, name: value }))}
              devices={systemForm.devices}
              onAddDevice={handleAddDeviceToForm}
              onDeleteDevice={handleDeleteDeviceFromForm}
              deviceInput={systemDeviceInput}
              onDeviceInputChange={setSystemDeviceInput}
              nameError={
                systemForm.name !== "" && !systemNameTrimmed
                  ? "System name is required"
                  : isDuplicateSystemName
                    ? "A system with this name already exists"
                    : ""
              }
            />
          }
          actions={
            <>
              <Button onClick={closeSystemDialog} color="inherit" disabled={savingDeviceList}>
                Cancel
              </Button>
              <Button
                onClick={handleSaveSystem}
                variant="contained"
                disabled={!systemNameTrimmed || isDuplicateSystemName || savingDeviceList}
              >
                {editingSystemName ? "Update" : "Add"}
              </Button>
            </>
          }
        />
      </div>
    ),
  };

  return (
    <Box sx={{ mt: 2, display: "flex", gap: 2, height: "calc(100vh - 160px)", overflow: "hidden" }}>
      {/* Sidebar List */}
      <Card sx={{ width: 280, height: "100%", display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" sx={{ p: 2, pb: 1, borderBottom: "1px solid #f0f0f0" }}>
          Admin Settings
        </Typography>
        <Box sx={{ overflowY: "auto", flex: 1, p: 1 }}>
          <List>
            {[...ADMIN_SIDEBAR_MENUS]
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((item) => (
                <ListItemButton
                  key={item.id}
                  selected={selectedForm === item.id}
                  onClick={() => {
                    setSelectedForm(item.id);
                    if (item.id === "Companysettings") companysetting();
                    if (item.id === "LLMSetup") getLLMsetup();
                    if (item.id === "deviceList") getDeviceList();
                  }}
                  sx={{
                    borderRadius: "8px",
                    mb: 0.5,
                    p: "10px 16px",
                    "&.Mui-selected": {
                      bgcolor: "#2550D1",
                      "&:hover": {
                        bgcolor: "#2550D1",
                      },
                    },
                    "&:hover": {
                      bgcolor: "#2550D1",
                      "& .MuiTypography-root": {
                        color: "#ffffff",
                      },
                    },
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: selectedForm === item.id ? 600 : 400,
                      color: selectedForm === item.id ? "#ffffff" : "#404040",
                    }}
                  />
                </ListItemButton>
              ))}
          </List>
        </Box>
      </Card>

      {/* Main Form Area */}
      <Box flex={1} sx={{ height: "100%", overflowY: "auto", pr: 1, pb: 2 }}>
        {selectedForm ? (
          <Card sx={{ p: 3, minHeight: "100%" }}>{formComponents[selectedForm]}</Card>
        ) : (
          <Typography variant="h6" sx={{ mt: 5, textAlign: "center" }}>
            Please select an option from the sidebar
          </Typography>
        )}
      </Box>
    </Box>
  );
}
